import { Text, YStack } from '@frontend/web-react';

type HeadsUpBannerProps = {
  message: string;
};

export const HeadsUpBanner = ({ message }: HeadsUpBannerProps) => (
  <YStack className="p-md bg-red-100">
    <Text className="text-red-900" type="h3">
      {message}
    </Text>
  </YStack>
);
